export class SiteMethods {
    static hello() : string {
        return "Hello";
    }

    static world() : string {
        return "World";
    }
}
